var beneficiaryMaritalStatuses = {
    Married: "M",
    Single: "S"
};

export default beneficiaryMaritalStatuses;
